import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { CycleInfo } from '../../model/CycleInfo.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cycle',
  templateUrl: './cycle.component.html',
  styleUrls: ['./cycle.component.css']
})
export class CycleComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;

  //Cycle Model
  ListStatus: LookupInfo[] = [];
  ListCycleManagement: CycleInfo[] = [];
  CycleInfo: CycleInfo = new CycleInfo;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchCycleName: string;
  txtSchCycleCode: string;
  ddlSchCycleStatus: string = "";

  //Form variable
  CycleForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalCycle: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchCycleStatus = 'Y'

    //Load init data
    this.LoadLookupType("CycleSTATUS").then((data) => {
      this.ListStatus = data;
    });
   
    this.LoadCycleList().then((data) => {
      this.ListCycleManagement = data;
    });
    this.LoadCountCycleList();

    //Declare form
    this.CycleForm = new FormGroup({
      CycleCode: new FormControl(this.CycleInfo.CycleCode, [Validators.required]),
      CycleName: new FormControl(this.CycleInfo.CycleName, [Validators.required]),
    });
  }

  get CycleCode() { return this.CycleForm.get('CycleCode'); }
  get CycleName() { return this.CycleForm.get('CycleName'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadCycleList(dataId: number = 0): Promise<CycleInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['CycleCode'] = this.txtSchCycleCode;
      objectjson['CycleName'] = this.txtSchCycleName;
      
      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<CycleInfo[]>(this.baseurl + "MasterSale/GetCycleManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountCycleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CycleCode'] = this.txtSchCycleCode;
      objectjson['CycleName'] = this.txtSchCycleName;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "MasterSale/GetCountCycleManagementList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadCycleList().then((data) => {
      this.ListCycleManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchCycleCode = null;
    this.txtSchCycleName = null;
    $('#ddlSchCycleStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadCycleList().then((data) => {
      this.ListCycleManagement = data;
    });
  }

  //Create btn
  OnCreateCycle_Click() {

    $('#modalCreateCycleTitle').html('Create Cycle DOA');
    $('#modalCreateOrEditCycle').modal();
    this.CycleInfo = new CycleInfo;
    this.CycleCode.setValue(null);
    this.CycleName.setValue(null);

    this.CycleForm.markAsUntouched();
    this.CycleForm.markAsPristine();
  }

  async OnSubmitCreateCycle_Click() {
    if (this.CycleForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.CycleForm.value;
        objectjson['CycleCode'] = this.CycleForm.get('CycleCode').value;
        objectjson['CycleName'] = this.CycleForm.get('CycleName').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/InsertCycleManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'Cycle has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditCycle').modal('hide');

            //Reload
            this.LoadCycleList().then((data) => {
              this.ListCycleManagement = data;
            });
            this.LoadCountCycleList();
          });
      }
    } else {
      this.markFormGroupTouched(this.CycleForm);
    }

  }
  async OnEdit_Click(CycleId) {

    if (!!CycleId) {
    
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadCycleList(CycleId).then((data) => {

          this.CycleInfo = data[0];
          this.CycleCode.setValue(data[0].CycleCode);
          this.CycleName.setValue(data[0].CycleName);

          setTimeout(() => {

            $('#modalCreateCycleTitle').html('Edit Cycle DOA');
            $('#modalCreateOrEditCycle').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.CycleForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.CycleForm.value;
        objectjson['CycleCode'] = this.CycleForm.get('CycleCode').value;
        objectjson['CycleName'] = this.CycleForm.get('CycleName').value;
        

        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.CycleInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/UpdateCycleManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'Cycle has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditCycle').modal('hide');

              //Reload
              this.LoadCycleList().then((data) => {
                this.ListCycleManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditCycle').modal('hide');

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.CycleForm);
    }
  }
  async OnDelete_Click(CycleId) {
    if (!!CycleId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.CycleForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = CycleId;

        let arrjson: CycleInfo[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteCycleManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.isSearchSubmitted = false;
              this.titlemodal = '';
              this.detailmodal = 'Cycle has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Reload
              this.LoadCycleList().then((data) => {
                this.ListCycleManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

            }
          });
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: CycleInfo[] = [];

    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new CycleInfo;
      model.Id = curId;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these DOA?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteCycleManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'Cycles have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadCycleList().then((data) => {
                    this.ListCycleManagement = data;
                  });
                  this.LoadCountCycleList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at lease 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }
  async OnMapping_Click(wfType, groupCode) {
    this.router.navigate(['/Cycle-doa-mapping', { wf: wfType, groupcode: groupCode }])
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadCycleList(positionId).then((data) => {

          this.CycleInfo = data[0];
          this.CycleCode.setValue(data[0].CycleCode);
          this.CycleName.setValue(data[0].CycleName);

          setTimeout(() => {

            $('#modalCreateCycleTitle').html('Edit Cycle');
            $('#modalCreateOrEditCycle').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['CycleCode'] = this.CycleCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "MasterSale/CheckDuplicateCycleManagementCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadCycleList().then((data) => {
      this.ListCycleManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalCycle = data;
    if (this.totalCycle == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalCycle / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
